<template>
    <div class="widget profile-widget">
        <div class="widget-body">
            <div class="user-profile-info">
                <base-user-details
                    has-edit-link
                    has-upgrade-button
                    layout="large"
                >
                    <base-user-avatar size="large" />
                </base-user-details>
            </div>
        </div>
        <div
            v-if="user.pro && hasLicenses"
            class="licenses"
        >
            <p>
                Use this key to activate the license in your WordPress site:
            </p>
            <div
                v-if="false === filteredLicenses"
                class="loader"
            >
                <i class="fas fa-spinner fa-spin loader" />
            </div>
            <base-license-key
                v-for="license in filteredLicenses"
                v-else
                :key="license.id"
                :license="license"
            />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { isEmpty, filter } from 'lodash';

export default {
    /**
     * @returns {Array} Data.
     */
    data() {
        return {
            changelog: null,
        };
    },

    computed: {
        ...mapState(['user', 'licenses', 'currentSubscription']),
        ...mapGetters(['totalLicenseSeats']),

        /**
         * Return filtered licenses for current subscription.
         *
         * @returns {Array} Licenses array.
         */
        filteredLicenses() {
            if (! this.currentSubscription) {
                return [];
            }

            return filter(this.licenses, { subscription_id: this.currentSubscription.id });
        },

        /**
         * Check if there are any licenses.
         *
         * @returns {boolean} Whether the licenses is not empty.
         */
        hasLicenses() {
            return ! isEmpty(this.filteredLicenses);
        },
    },

    methods: {
        /**
         * Chandles changelog link click.
         *
         * @param   {string} changelog Changelog content.
         * @returns {void}
         */
        onChangelogClick(changelog) {
            this.changelog = changelog;
            this.toggleChangelogModal();
        },
    },
};
</script>
